import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UserCredentials } from '../models/Credentials.model';
import { RequestService } from '../services/request.service';
import { MatDialog } from '@angular/material/dialog';
import { SettingsComponent } from '../settings/settings.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  private unscubscribe$ = new Subject<void>();
  version: string = '1.0.0-alpha';
  title = 'TrainOptimizer ' + this.version;

  companyNav = { title: "Company", list: "Company List", createOrEdit: "Add New Company / Edit Existing Company" };
  userNav = { title: "Manage Users", list: "User List", createOrEdit: "Add New User / Edit Existing User" };
  projectNav = { title: "Project", list: "Project List", createOrEdit: "Add New Project / Edit Existing Project" };
  waggonNav = { title: "Carriage / Train", list: "Carriage / Train List", createOrEdit: "Add New Carriage / Train" };
  evaluationNav = { title: "Analysis", list: "", createOrEdit: "" };
  userMenuNav = { title: "Hello ", settings: "Settings", logOut: "Log Out", suffix: " / My Account" };
  datamanagementNav = { title: "Manage Data", list: "", createOrEdit: "" };
  currentUrl;

  constructor(
    public authService: AuthService,
    private router: Router,
    private requestService: RequestService,
    public dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.router.events.pipe(filter((event => event instanceof (RoutesRecognized)))).pipe(takeUntil(this.unscubscribe$)).subscribe((r: RoutesRecognized) => {
      this.currentUrl = r.url.split('/')[1];
    })
  }

  isActive(tab): boolean {
    if (tab === this.currentUrl) {
      return true;
    }
    return false;
  }

  userSettings() {
    const dialogRef = this.dialog.open(SettingsComponent,
      {
        width: '420px',
        data: {
          email: this.authService.getCurrentEmail()
        }
      });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.save) {
        let credential: UserCredentials = new UserCredentials();
        credential.email = result.data.email;
        credential.password = result.data.password;
        this.requestService.overridePassword(credential).pipe(takeUntil(this.unscubscribe$))
          .subscribe(resp => {
          });
      }
    })
  }

  ngOnDestroy(): void {
    this.unscubscribe$.next();
    this.unscubscribe$.complete();
  }
}